import { Routes } from '@angular/router';
import { WhiteLabelService } from './app/services/white-label.service';
import { maintenanceGuard } from './app/services/maintenance.guard';


export const routes: Routes = [
  {path: '', redirectTo: '/app-home', pathMatch: 'full'},
  {path: 'app-home', loadComponent: () => import('./app/app-home/app-home.component').then(c => c.AppHomeComponent) },
  {path: 'opusmusic', 
  loadComponent: () => import('./app/app-home/app-home.component').then(c => c.AppHomeComponent),
  canActivate:  [WhiteLabelService], data: {id: 'opusmusic'}},
  {path: 'vevasound', 
  loadComponent: () => import('./app/app-home/app-home.component').then(c => c.AppHomeComponent),
  canActivate:  [WhiteLabelService], data: {id: 'vevasound'}},
  {path: 'bridger', 
  loadComponent: () => import('./app/app-home/app-home.component').then(c => c.AppHomeComponent),
  canActivate:  [WhiteLabelService], data: {id: 'bridger'}},
  {path: 'lorelai-lab', 
  loadComponent: () => import('./app/app-home/app-home.component').then(c => c.AppHomeComponent),
   canActivate:  [WhiteLabelService], data: {id: 'lorelailab'}},
  {path: 'metamusique', 
  loadComponent: () => import('./app/app-home/app-home.component').then(c => c.AppHomeComponent),
   canActivate:  [WhiteLabelService], data: {id: 'metamusique'}},
  {path: 'warner', 
  loadComponent: () => import('./app/app-home/app-home.component').then(c => c.AppHomeComponent),
   canActivate:  [WhiteLabelService], data: {id: 'warner'}},
 
  // Everything that can start or complete a registration sits behind the maintenance
  // guard. app-checkout-success and app-checkout-cancel deliberately stay open: a
  // visitor who paid just before the pause must still be able to land back on them.
  {path: 'maintenance', loadComponent: () => import('./app/maintenance/maintenance.component').then(c => c.MaintenanceComponent) },

  // Manual environment checks. Not guarded here: every endpoint it calls requires the
  // BFF's preview key, so the page is inert without it.
  {path: 'diagnostics', loadComponent: () => import('./app/diagnostics/diagnostics.component').then(c => c.DiagnosticsComponent) },

  {path: 'app-isni', canActivate: [maintenanceGuard], loadComponent: () => import('./app/app-isni/app-isni.component').then(c => c.AppIsniComponent) },
  {path: 'app-isni-person', canActivate: [maintenanceGuard], loadComponent: () => import('./app/app-isni-person/app-isni-person.component').then(c => c.AppIsniPersonComponent) },
  {path: 'app-isni-band', canActivate: [maintenanceGuard], loadComponent: () => import('./app/app-isni-band/app-isni-band.component').then(c => c.AppIsniBandComponent) },
  {path: 'app-isni-label', canActivate: [maintenanceGuard], loadComponent: () => import('./app/app-isni-label/app-isni-label.component').then(c => c.AppIsniLabelComponent) },
  {path: 'app-isrc', canActivate: [maintenanceGuard], loadComponent: () => import('./app/app-isrc/app-isrc.component').then(c => c.AppIsrcComponent) },
  {path: 'app-cart', canActivate: [maintenanceGuard], loadComponent: () => import('./app/app-cart/app-cart.component').then(c => c.AppCartComponent) },
  {path: 'app-faq', loadComponent: () => import('./app/app-faq/app-faq.component').then(c => c.AppFaqComponent) },
  {path: "app-checkout-success", loadComponent: () => import('./app/app-checkout-success/app-checkout-success.component').then(c => c.AppCheckoutSuccessComponent) },
  {path: "app-checkout-cancel", loadComponent: () => import('./app/app-checkout-cancel/app-checkout-cancel.component').then(c => c.AppCheckoutCancelComponent) },
  {path: "app-test-ts", loadComponent: () => import('./app/app-test/app-test.component').then(c => c.AppTestComponent) },
]
